<template>
  <div class="container">
    <div class="container-page">
      <img class="iamge-page" src="../assets/img/page.png" alt="">
      <div class="image-box">
        <img v-if="showImage" class="image" :src="require('../assets/img/img.jpeg')" />
        <img class="image" id="cropImg" :src="cropImage">
      </div>
      <div v-if="showCropper">
        <div class="cropper-btn">
          <div @click="showCropper=false">取消</div>
          <div @click="drawcropImage">确定</div>
        </div>
        <div class="cropper-box">
          <div class="cropper-img">
            <vue-cropper
              ref="cropper"
              id="cropperid"
              :src="cropperimage"
              :aspect-ratio="4 / 3"
              :minCropBoxWidth="300"
              :minCropBoxHeight="300"
            />
        </div>
        </div>
      </div>
      <div class="submit"> 
        <van-button
          v-if="showImage"
          @click="showImage = false"
          class="submit-btn button glass"
          type="default"
          round
          color="linear-gradient(to right, #e53531, #f48260)"
          native-type="submit"
        >
          定制我的头版
        </van-button>
        <div class="bottom-btn" v-if="!showImage">
          <van-uploader ref="input" @change="setImage">
            <div
              class="input-btn"
            >
              {{ cropImg ? "重新上传": "上传照片"}}
            </div> 
          </van-uploader>
          <div
              @click="draw"
              class="input-btn"
          >
            生成海报
          </div> 
        </div>
      
    </div>
    </div>
  </div>
  <PosterMerge />
</template>

<script>
import {
  Popup,
  Picker,
  Dialog,
  Form,
  Field,
  Button,
  Uploader,
  Icon,
  DatetimePicker,
  CountDown,
  Toast
} from "vant"
import { wxshareInit, wxCloseWindow } from "@/plugins/wechatSDK.js"
import "@/plugins/bridge.js"
import { computed } from "vue"
import { useStore } from "vuex"
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { compress,  drawPoster } from "@/utils/beforUploadFn.js"
import PosterMerge from "@/components/PosterMerge.vue"

export default {
  name: "Home",
  components: {
    [CountDown.name]: CountDown,
    [DatetimePicker.name]: DatetimePicker,
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    VueCropper,
    PosterMerge,
    // Cropper
  },
  data() {
    return {
      cropperimage: "",
      showCropper: false,
      showImage: true,
      cropImg: "",
      file: {},
      args: {},
    }
  },
  methods: {
    setImage(e) {
      const file = e.target.files[0];
      if (!/image\/[a-zA-z]+/.test(file.type)) {
        Toast("请上传正确格式的图片")
      } else {
          if (!file || !window.FileReader) return;
          const toast = Toast.loading({
            message: '加载中...',
            forbidClick: false,
          });
          const reader = new FileReader();
          this.showCropper = true
          reader.onload = (event) => {
            this.imgSrc = event.target.result; 
            file.content = event.target.result;
            this.file = file;
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result);
						toast.clear();
            // console.log(this.$refs.cropper);
          };
        reader.readAsDataURL(file);
      } 
    },
    drawcropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.$store.state.compresIamge = this.cropImg;
      compress(this.cropImg, this.file).then(res => {
        res.content = this.cropImg;
        this.$store.state.compresFile = res;
        this.$store.state.cropImage = res.content;
        // this.$store.dispatch("uploadImg", res);
      })
      this.showCropper = false
    },
    draw() {
      let that = this;
      const image = this.$store.state.compresIamge;
      if (!image) {
        Toast("请上传照片");
        return;
      }
      let cropimage = new Image();
      cropimage.src = image;
      let w;
      let h;
      let args;
      cropimage.onload = function () {
        w = cropimage.naturalWidth;
        h = cropimage.naturalHeight;
        //  sx, sy, sw, sh, dx, dy, dw, dh
        args = {
          sx: 0,
          sy: 0,
          sw: w,
          sh: h,
          dx: 163,
          dy: 960,
          dw: 848,
          dh: 610,
        }
      drawPoster(image, args).then(res => {
          console.log("合成成功", res);
          that.$store.state.poster = res;
          that.$store.commit("updateShowPosterMerge", true)
        })
      }
    },
  closePage () {
    const userAgentString = navigator.userAgent.toLowerCase()
    
     if(navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {  
        open(location, "_self").close();
        window.location.href="about:blank";  
        window.close();  
	    } else if (userAgentString.indexOf("zsrbapp") >= 0) {
         window.ZsrbApp.call("back")
      } else {
          wxCloseWindow();
	        window.opener = null;  
	        window.open("", "_self");  
	        window.close(); 
	        open(location, "_self").close();
	    } 
    }
  },
created() {
    const curtime = Date.parse(new Date());
    if (curtime < 1654185600000) {
      Dialog.alert({
        message: '当前活动未开始，6月3日再来吧！',
      }).then(() => {
        // window.close();
        this.closePage();
      });
    } else if (curtime >= 1654268400000) {
      Dialog.alert({
        message: '当前活动已结束哦，下次早点来参加吧！',
      }).then(() => {
        // window.close();
        this.closePage();
      });
    }
    window.ZsrbApp.call("shareInfo", {
      title: "中山日报10000期，给你道万福，快来生成你的专属头条",
      img: "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.jpg"),
      desc: "中山日报 出品",
      url: "https://zsrbactivity.zsnews.cn/vue/poster/"
    })
    wxshareInit({
      title: "中山日报10000期，给你道万福，快来生成你的专属头条",
      imgUrl: "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.jpg"),
      description: "中山日报 出品",
      url: "https://zsrbactivity.zsnews.cn/vue/poster/",
      successMethod: ""
    })
  },
  setup() {
    const store = useStore()
    return {
      cropImage: computed(() => store.state.cropImage), //当前上传的图片
    }
  },
  
}
</script>

<style lang="scss" scoped>
.van-cell {
  --van-cell-border-color: none;
  margin-bottom: 15px;
}
.container {
  width: 100%;
  background: url('../assets/img/background.jpg') no-repeat;
  background-color: #6a1f15;
  background-size: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-page {
  position: relative;
  .iamge-page {
    width: 90%;
    height: auto;
  }
}
.image-box {
  position: absolute;
  top: 73vw;
}
.image {
  width: 62%;
}

.header {
  width: 100%;
  height: auto;
  left: 0;
  top: 0;
}

.submit {
  margin-top: 5vw;
}
.submit-btn {
  width: 50%;
}
.bottom-btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
.input-btn {
  width: 120px;
  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  background: linear-gradient(to right, #e53531, #f48260);
  color: #ffffff;
  margin: 0px 16px;
}
.input {
  visibility: hidden;
  width: 120px;
}
.statement {
  position: absolute;
  z-index: 100;
  height: 26px;
  width: 60px;
  top: 31px;
  right: 0;
  background-color: rgba($color: #323233, $alpha: 0.7);
  border-radius: 12px 0 0 12px;
  color: white;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  .statement-title {
    line-height: 26px;
  }
}
#img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  -webkit-touch-callout: none;
}
.count-text {
  width: 100%;
  height: 28px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 14px;
  .time {
    line-height: 28px;
    font-size: 3.4vw;
  }
}
.cropper-box {
  user-select: none;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2;
}

.cropper-img {
   width: 100%;
}

.cropper-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  position: fixed;
  display: flex;
  bottom: 0px;
  justify-content: space-around;
  background: #ffffff;
  z-index: 6;
  padding-bottom: env(safe-area-inset-bottom);
}

</style>
